import type { User } from '@/server/models'

import type { UserContextType } from '@/client/context/user'

export default function isUserOnboarding(
  user: Pick<User, 'id' | 'onboarding_details'> | Pick<UserContextType, 'id' | 'isOnboarding'>
): boolean {
  if (user.id === 0 || user.id == null) {
    return false
  }
  if ('isOnboarding' in user) {
    return user.isOnboarding
  }
  return user.onboarding_details == null
}
